import { render } from "./admin-list.vue?vue&type=template&id=68030448&scoped=true&ts=true"
import script from "./admin-list.vue?vue&type=script&lang=ts"
export * from "./admin-list.vue?vue&type=script&lang=ts"

import "./admin-list.vue?vue&type=style&index=0&id=68030448&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68030448"]])

export default __exports__